import React from "react";

const FitSection = () => {
	return (
		<div className="FitSection bg-[#272727] text-white py-16 md:py-24 px-2 xl:px-0 overflow-hidden relative">
			<div className="container mx-auto px-4 max-w-7xl relative z-10">
				{/* Top Headline */}
				<div className="text-center mb-12 md:mb-20">
					<h2 className="text-[clamp(24px,2.57vw,36px)] font-bold mb-6 leading-tight">
						A Development Partner Built <br className="hidden md:block" />
						for BOTH Sides of Your Mandate
					</h2>
				</div>

				{/* Desktop/Tablet: Horizontal Venn Diagram */}
				<div
					className="hidden md:block relative w-full max-w-5xl mx-auto"
					style={{ aspectRatio: "16/9" }}
				>
					{/* Circle 1: Left - positioned from center */}
					<div
						className="absolute top-1/2 left-1/2 rounded-full border-2 border-dotted"
						style={{
							width: "60%",
							paddingBottom: "60%",
							transform: "translate(-72%, -50%)",
							borderColor: "#6C84FA",
							borderWidth: "3px",
							borderStyle: "dashed",
							borderSpacing: "10px",
						}}
					>
						<div className="absolute inset-0 flex items-center justify-start pl-[8%]">
							<p className="font-bold text-white text-center leading-relaxed max-w-[180px] text-sm lg:text-base">
								Designing software people love to use that is intuitive, sleek, and modern.
							</p>
						</div>
					</div>

					{/* Circle 2: Right - positioned from center */}
					<div
						className="absolute top-1/2 left-1/2 rounded-full border-2 border-dotted"
						style={{
							width: "60%",
							paddingBottom: "60%",
							transform: "translate(-28%, -50%)",
							borderColor: "#6C84FA",
							borderWidth: "3px",
							borderStyle: "dashed",
							borderSpacing: "10px",
						}}
					>
						<div className="absolute inset-0 flex items-center justify-end pr-[8%]">
							<p className="font-bold text-white text-center leading-relaxed max-w-[180px] text-sm lg:text-base">
								Shipping quality code faster with shorter release cycles
							</p>
						</div>
					</div>

					{/* Intersection: Middle - with solid background */}
					<div
						className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 bg-[#3a4a5c] rounded-[50%]"
						style={{
							width: "38%",
							height: "85%",
						}}
					/>
					<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 text-center w-[300px] lg:w-[360px]">
						<div className="mb-6">
							<h3 className="text-lg lg:text-2xl text-white mb-2">
								Most partners can do one.
							</h3>
							<h3 className="text-lg lg:text-2xl font-bold text-white">Crafted does both.</h3>
						</div>

						<ul className="text-left space-y-3 text-gray-300 text-sm lg:text-base">
							<li className="flex items-start">
								<svg className="mr-2 flex-shrink-0 mt-1" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1 6L5.5 10.5L14.5 1.5" stroke="#5EEAD4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
								<span>Delivering lovable UX with refined taste and creative sensitivity</span>
							</li>
							<li className="flex items-start">
								<svg className="mr-2 flex-shrink-0 mt-1" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1 6L5.5 10.5L14.5 1.5" stroke="#5EEAD4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
								<span>
									Shipping faster than internal teams through disciplined execution + AI-native
									workflows
								</span>
							</li>
							<li className="flex items-start">
								<svg className="mr-2 flex-shrink-0 mt-1" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1 6L5.5 10.5L14.5 1.5" stroke="#5EEAD4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
								<span>
									Supporting your roadmap as an integrated, long-term partner — not a transactional
									vendor
								</span>
							</li>
						</ul>
					</div>
				</div>

				{/* Mobile: Stacked vertical layout */}
				<div className="md:hidden flex flex-col items-center gap-8">
					{/* Left circle content */}
					<div className="w-[280px] h-[280px] rounded-full border-2 border-dashed flex items-center justify-center p-8" style={{borderColor: "#6C84FA", borderWidth: "3px"}}>
						<p className="font-bold text-white text-center leading-relaxed text-sm">
							Designing software people love to use that is intuitive, sleek, and modern.
						</p>
					</div>

					{/* Middle content */}
					<div className="text-center max-w-sm px-4">
						<div className="mb-6">
							<h3 className="text-xl text-white mb-2">Most partners can do one.</h3>
							<h3 className="text-xl font-bold text-white">Crafted does both.</h3>
						</div>

						<ul className="text-left space-y-4 text-gray-300 text-sm">
							<li className="flex items-start">
								<svg className="mr-3 flex-shrink-0 mt-1" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1 6L5.5 10.5L14.5 1.5" stroke="#5EEAD4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
								<span>Delivering lovable UX with refined taste and creative sensitivity</span>
							</li>
							<li className="flex items-start">
								<svg className="mr-3 flex-shrink-0 mt-1" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1 6L5.5 10.5L14.5 1.5" stroke="#5EEAD4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
								<span>
									Shipping faster than internal teams through disciplined execution + AI-native
									workflows
								</span>
							</li>
							<li className="flex items-start">
								<svg className="mr-3 flex-shrink-0 mt-1" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M1 6L5.5 10.5L14.5 1.5" stroke="#5EEAD4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
								<span>
									Supporting your roadmap as an integrated, long-term partner — not a transactional
									vendor
								</span>
							</li>
						</ul>
					</div>

					{/* Right circle content */}
					<div className="w-[280px] h-[280px] rounded-full border-2 border-dashed flex items-center justify-center p-8" style={{borderColor: "#6C84FA", borderWidth: "3px"}}>
						<p className="font-bold text-white text-center leading-relaxed text-sm">
							Shipping quality code faster with shorter release cycles
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FitSection;
